import EnergyConsumptionIcon from './component'

export default EnergyConsumptionIcon
